module.exports = {
  ENTITY_PERSON_TYPE: {
    PRIMARY_CONTACT: 'PRIMARY_CONTACT',
    STAKEHOLDER: 'STAKEHOLDER',
    USER: 'USER',
    TEAM_MEMBER: 'TEAM_MEMBER'
  },
  ENTITY_PERSON_GENDER: {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER'
  },
  ENTITY_PERSON_IDENTIFICATION_TYPE: {
    NONE: 'NONE',
    DRIVERS_LICENCE: 'DRIVERS_LICENCE',
    SOCIAL_SECURITY_NUMBER: 'SOCIAL_SECURITY_NUMBER',
    GREEN_CARD: 'GREEN_CARD',
    PASSPORT: 'PASSPORT',
    VISA: 'VISA',
    CITIZENSHIP_PAPERS: 'CITIZENSHIP_PAPERS',
    DRIVERS_LICENSE_CANADIAN: 'DRIVERS_LICENSE_CANADIAN',
    EMPLOYER_IDENTIFICATION_NUMBER: 'EMPLOYER_IDENTIFICATION_NUMBER',
    NATIONAL_ID: 'NATIONAL_ID',
    OTHERS: 'OTHERS'
  },
  ENTITY_PERSON_TAX_ID_TYPE: {
    SSN: 'SSN',
    EIN: 'EIN',
    ITIN: 'ITIN',
    VAT: 'VAT',
    FOREIGN: 'FOREIGN'
  },
  ENTITY_PERSON_RISK_RATING: {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
  },
  ENTITY_PERSON_STATUS: {
    NEW_RECORD: 'NEW_RECORD',
    INVITATION_SENT: 'INVITATION_SENT',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
  },
  ONBOARDING_STEPS: {
    SIGNUP: 'SIGNUP',
    ACCEPT_INVITE: 'ACCEPT_INVITE',
    ACCEPT_CONTROLLING_PARTY_CONSENT: 'ACCEPT_CONTROLLING_PARTY_CONSENT',
    ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS',
    COMMUNICATION_ADDRESS: 'COMMUNICATION_ADDRESS'
  },
  REQUIRED_ONBOARDING_STEPS_FOR_PRIMARY_PERSON: {
    // SIGNUP: 'SIGNUP',
    // ACCEPT_INVITE: 'ACCEPT_INVITE',
    // ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS',
    COMMUNICATION_ADDRESS: 'COMMUNICATION_ADDRESS'
  },
  REQUIRED_ONBOARDING_STEPS_FOR_SMARTLINK_USER: {
    SIGNUP: 'SIGNUP',
    ACCEPT_INVITE: 'ACCEPT_INVITE',
    ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS',
    COMMUNICATION_ADDRESS: 'COMMUNICATION_ADDRESS'
  },
  REQUIRED_ONBOARDING_STEPS_FOR_ADMIN: {
    SIGNUP: 'SIGNUP',
    ACCEPT_INVITE: 'ACCEPT_INVITE',
    ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS'
  },
  REQUIRED_ONBOARDING_STEPS_FOR_STAKEHOLDER: {
    ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS'
  },
  REQUIRED_ONBOARDING_STEPS_FOR_CONTROLLING_PARTY: {
    ACCEPT_CONTROLLING_PARTY_CONSENT: 'ACCEPT_CONTROLLING_PARTY_CONSENT',
    ACCEPT_CONFIDENTIAL_AGREEMENT: 'ACCEPT_CONFIDENTIAL_AGREEMENT',
    ID_VERIFICATION: 'ID_VERIFICATION',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    PRIMARY_ADDRESS: 'PRIMARY_ADDRESS'
  }
};
